import { BoardGridApi, BoardGridRow, boardGridStepRow, isBoardGridRowSelectable } from './board.grid.keyboard';

/**
 * The displayed row a one-row step lands on, skipping group chrome and rows without data.
 *
 * Returns `from` itself at the edge (boardGridStepRow holds there), and null when nothing selectable
 * lies in `direction`. Collapsed children are not displayed, so a step never lands inside a closed group.
 */
export function boardGridNextSelectableRow(api: BoardGridApi, from: number | null, direction: 1 | -1, includeGroups = false): number | null {

  let next = boardGridStepRow(api, from, direction);
  while (next != null) {
    const node = api.getDisplayedRowAtIndex(next);
    if (node && isBoardGridRowSelectable(node, includeGroups) && node.data) return next;
    const further = boardGridStepRow(api, next, direction);
    if (further == null || further === next) return null;
    next = further;
  }
  return null;
}

/**
 * The record ids a grid shows, top to bottom. Collapsed children are not displayed rows, so they never
 * appear; `recordIdOf` answers null for anything that is not a record (group chrome, SSRM stubs).
 */
export function boardGridVisibleOrder(api: BoardGridApi | null | undefined, recordIdOf: (row: BoardGridRow) => string | null | undefined): string[] {

  if (!api) return [];
  const order: string[] = [];
  const rowCount = api.getDisplayedRowCount();
  for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
    const row = api.getDisplayedRowAtIndex(rowIndex);
    const id = row ? recordIdOf(row) : null;
    if (id != null && id !== '') order.push(id);
  }
  return order;
}
